export const ARCHIVED_TOOLTIP_MESSAGE = "This to-do has been archived and can no longer be edited.";
export const DOWNLOAD_PERMISSION_MESSAGE = "You don't have permission to download this submission.";
export const READ_ONLY_TOOLTIP_MESSAGE = "You don't have permission to update this to-do.";
export const UPLOAD_UNAVAILABLE_TOOLTIP_MESSAGE = "This to-do doesn't accept file uploads.";

export const BYTES_PER_UNIT: Record<string, number> = {
  kb: 1024,
  mb: 1024 * 1024,
  gb: 1024 * 1024 * 1024,
};

// To-dos that accept files and whose profile-service form stores them.
export const UPLOAD_TODO_IDS = {
  COVER_LETTER: "80ee1b3a-c21c-47b1-9bd4-d074ca5f4819",
  GRADE_REPORT: "da9995c5-ac1b-464d-b8f7-7a89d7b80d82",
  HEADSHOT: "42aefac7-19a5-4419-b28d-243a507c8bbc",
  LDM_REGISTRATION_POLICY: "f6425899-69bd-4e37-a77d-b2f2ff50ab4f",
  PASSPORT: "d2c8796d-1d37-4c14-a28d-ae6b080407c2",
  RESUME: "864fd2d8-d520-48bd-9299-b38c5c3122de",
  STATEMENT_OF_PURPOSE: "7c585fab-6517-470c-8d9d-7bb0a2e87949",
  SUPPLEMENTAL_FORM_1: "d00e3eff-5549-41fb-b87d-9a29c7587754",
  SUPPLEMENTAL_FORM_2: "ebd00197-f50c-4f19-b242-6bd4a1551c13",
  SUPPLEMENTAL_FORM_3: "a266a1a1-8b36-4a92-90cd-e4008b40b4fb",
  SUPPLEMENTAL_FORM_4: "04605202-ef20-4ffb-8b8e-a47c71b7acc5",
  UNOFFICIAL_TRANSCRIPT: "58428b4e-121f-4b5c-b28f-d0880609d190",
  VISA_AND_PERMITS: "34bc4ee9-cab3-4d94-b9fd-f854adc68183",
} as const;

export const LOR_TODO_IDS: readonly string[] = [
  "50f7afe0-d500-43f0-b2ac-aea1cb01fbbd",
  "da0d6aeb-baa6-40a6-a812-73a38b22f788",
];

export const LOR_FORM_PATH = "letterOfRecommendationAbroad";

export const RECOMMENDER_NAME_FIELD = "yourName";
export const RECOMMENDER_TITLE_FIELD = "yourProfessionalTitle";
export const RECOMMENDER_ORGANIZATION_FIELD = "yourInstitution";
export const RECOMMENDER_EMAIL_FIELD = "yourEmail";
export const RECOMMENDER_PHONE_FIELD = "yourTelephone";

// Shown in the card header or on the attestation, so they are not question-and-answer rows.
export const NON_QUESTION_FIELDS: readonly string[] = [
  "applicationId",
  RECOMMENDER_NAME_FIELD,
  RECOMMENDER_TITLE_FIELD,
  RECOMMENDER_ORGANIZATION_FIELD,
  RECOMMENDER_EMAIL_FIELD,
  RECOMMENDER_PHONE_FIELD,
  "date",
  "signature",
  "submit",
];
